import { css } from 'lit';

export default css`
  /* Z-Index */
  --z-index-tooltip: 1000;          /* Tooltip layer */
  --z-index-overlay: 1500;          /* Overlay layer */
  --z-index-dialog: 2000;           /* Dialog layer */
  --z-index-menu: 1000;
`;
